import { Feature } from '../models/feature.model';

export function userHasFeature(features:Feature[], checkForFeature:number):boolean{
    var hasFeature:boolean = false;

    if(features != null && features.length > 0 && checkForFeature != null && checkForFeature > 0){
        for (let index = 0; index < features.length; index++) {
            const feature = features[index];
            if(feature.id === checkForFeature){
                hasFeature = true;
                break;
            }
        }
    }
    return hasFeature;
}